<template>
   <div id="page">
      <site-header title="Summit - Enterprise Monitoring"></site-header>
      <div class="content-row">
         <h1>Summit - Enterprise Monitoring</h1>
         <p>
            Summit is tailor-made unified monitoring, automation and analytics solution. Architectural components are designed to support enterprise automation, availability, performance, predictive and situation dashboard requirements.
         </p>
         <br>
         <h2>Key Considerations</h2>
         <ol>
            <li>An operationally and functionally superior monitoring offering</li>
            <li>A modular solution to utilize the best available option for each component</li>
            <li>An ecosystem of technologies with promising future support and talent outlook</li>
            <li>An infrastructure and vendor agnostic design</li>
            <li>A maintenance and operationally optimized offering to reduce total cost of ownership</li>
            <li>An attractive investment path for future business requirements</li>
         </ol>
         <br>
         <h2>High-Level Components</h2>
         <h3>Collectors</h3>
         <p>
            System and process events, logs and telemetry collected from target systems form the raw data needed to generate alerts, trigger automation workflows, assess performance, enable predictive insights and power situational dashboards. Summit collectors support a vast array of data sources through mechanisms such as logs collection, webhooks and SNMP endpoints.
         </p>
         <h3>Ingest</h3>
         <p>
            The Summit solution interfaces with the collector through the Ingest component which allows for heterogenous events to be submitted through a single HTTP endpoint. This endpoint will accept multiple schemas to account for the diverse events sources across an enterprise's complex technology ecosystem.
         </p>   
         <h3>Compute Engine</h3>
         <p>
            A core component of the Summit solution is the Summit Compute Engine. This component is powered by a best-in-class distributed compute engine. This engine powers a unified analytics engine for streaming and batch data processing.
         </p>
         <h3>Access Control</h3>
         <p>
            Access control and authorization is central to a multiuser environment. Summit uses Mobkast’s Fortress authorization engine which allows enterprise customers to describe user groups, access policies and a powerful tags schema to encapsulate many resource types. Fortress allows for powerful referencing to apply policies to tags or groups of tags using flexible patterns.
         </p>
         <h3>Automation</h3>
         <p>
            A monolithic automation service that satisfies a large set of enterprise automation requirements to include features such as auditing and RBAC, may present other challenges like requiring the deployment and managing of agents.

            Summit allows for integration with a host of modern automation engines to best suit the specific needs of enterprise customers.
         </p>
         <h3>Dashboards and Workflows</h3>
         <p>
            An enterprise wide monitoring strategy and platform will demand a host of stakeholder specific workflows and dashbaords. Here Mobkast's DashX apps platform can be used to effectively deploy new workflows to support business and functional requirements. The DashX platform features a modular apps engine with a granular access control system to gracefully support separation of data and views for different stakeholders.
         </p>
         <br>
         <p>
            To learn more about deploying Summit in your organization reach out to <b>team@mobkast.com</b>.
         </p>
      </div>
      <site-footer></site-footer>
   </div>
</template>

<script>
export default {
   data () {
      return {
         msg: ''
      }
   },
   methods: {
      preventMouseDown: (e) => {}
   }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

#page {
   height: auto;
   width: 64rem;
   margin: auto;
   font-size: 0.94rem;
   margin-bottom: 6rem;
}

.content-row {
   margin: auto;
   width: 86%;
}

.focus-bit {
   font-weight: 500;
}

h1 {
   margin: 4rem 4rem;
}


/* + Site Wide */
a, u {
    text-decoration: none;
}

a {
   color: #888888;
}
/* - Site Wide */

/* + Responsive UI */
@media screen and (max-width: 1040px) {
   #page { 
      width: auto;
   }
}

@media screen and (max-width: 740px) {
   #page { 
      width: auto;
   }

   h1 {
      margin: 2rem 1rem;  
      font-size: 1.6rem; 
   }

   h2 {
      font-size: 1.3rem; 
   }

   h3 {
      font-size: 1rem; 
   }
}

@media screen and (max-width: 480px) {
   #page { 
      width: auto;
   }
}
/* - Responsive UI */
</style>



// WEBPACK FOOTER //
// src/components/site/Summit.vue